import { EDITABLE_COMPONENT_STATE_MODEL } from 'common/constants';
import { SELECTION_TYPES } from 'client/components/common/SelectionHint/utils';
import { SelectionSingleType } from 'client/components/common/SelectionHint/types';

const initialState: {
	state: typeof EDITABLE_COMPONENT_STATE_MODEL;
	selection: {
		[SELECTION_TYPES.clicked]: {
			[key: string]: SelectionSingleType;
		};
		[SELECTION_TYPES.hovered]: {
			[key: string]: SelectionSingleType;
		};
	};
} = {
	state: EDITABLE_COMPONENT_STATE_MODEL,
	selection: {
		[SELECTION_TYPES.clicked]: {},
		[SELECTION_TYPES.hovered]: {},
		/*
		 [selectionType]: {
		    elementID: {...data},
		    elementID: {...data},
		 },
		*/
	},
};

export default initialState;
